import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /organizations/:orgId/*. Renders <Outlet /> so child routes
 * (`/` index = detail, `/edit` = edit form, `/locations/*` = nested) can mount
 * here. If this returned the detail screen directly, the edit + nested location
 * children would silently fail to render — same fix Modules 1 + 2 needed.
 */
export const Route = createFileRoute('/_staff/admin/workspace/organizations/$orgId')({
  beforeLoad: () => {
    requirePermission('org:read');
  },
  component: WorkspaceOrganizationLayout,
  staticData: { crumb: 'Organization' },
});

function WorkspaceOrganizationLayout() {
  return <Outlet />;
}
